import "./lib/monitoring/sentry"
import "./index.css"

import { ClerkProvider } from "@clerk/react"
import * as Sentry from "@sentry/react"
import { StrictMode, startTransition } from "react"
import { createRoot } from "react-dom/client"

import App from "@/App"
import { ThemeProvider } from "@/components/theme-provider"

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const container = document.getElementById("root")

const clerkLocalization = {
  locale: "en",
  signIn: {
    password: {
      title: "Enter your SafetyQR password",
    },
    start: {
      subtitle: "Welcome back. Please sign in to continue.",
      subtitleCombined: "Welcome back. Please sign in to continue.",
      title: "Sign in to SafetyQR",
      titleCombined: "Sign in to SafetyQR",
    },
  },
  signUp: {
    start: {
      subtitle: "Create your SafetyQR account to continue.",
      subtitleCombined: "Create your SafetyQR account to continue.",
      title: "Create your SafetyQR account",
      titleCombined: "Create your SafetyQR account",
    },
  },
} as const

if (!container) {
  throw new Error("Unable to mount v2 application shell: missing #root element")
}

if (!clerkPublishableKey) {
  throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY for ClerkProvider")
}

const root = createRoot(container, {
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
})

startTransition(() => {
  root.render(
    <StrictMode>
      <ClerkProvider
        afterSignOutUrl="/"
        localization={clerkLocalization}
        publishableKey={clerkPublishableKey}
        signInFallbackRedirectUrl="/account"
        signInUrl="/sign-in"
        signUpFallbackRedirectUrl="/account"
        signUpUrl="/sign-up"
      >
        <ThemeProvider defaultTheme="light">
          <App />
        </ThemeProvider>
      </ClerkProvider>
    </StrictMode>
  )
})
